import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'div[data-component-type=progress]',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('progressAnimation', [
    state('*', style({ width: '{{width}}' }), { params: { width: 0 } }),
    transition('* <=> *', animate('300ms ease'))
  ])]
})
export class ProgressComponent implements OnInit {

  @Input() progress$!: Observable<number>

  constructor() { }

  ngOnInit(): void {
  }

}
